module.exports = __webpack_public_path__ + "static/media/zw.9519a519.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/zw.svg
// module id = 2248
// module chunks = 0